/* eslint-disable react/no-array-index-key */
import { Children, Fragment } from "react";
import PropTypes from "prop-types";

import { STYLES } from "../common";

const PipedElements = ({ children, containerClassName }) => (
  <div className={`tw-flex tw-gap-8px tw-items-center ${containerClassName}`}>
    {Children.map(children, (element, index) => {
      if (!element?.props?.data && !element?.props?.children) return null;
      return (
        <Fragment key={index}>
          {index > 0 && <div className={STYLES.pipe} />}
          {element}
        </Fragment>
      );
    })}
  </div>
);

export default PipedElements;

PipedElements.propTypes = {
  children: PropTypes.arrayOf(PropTypes.elementType).isRequired,
  containerClassName: PropTypes.string,
};

PipedElements.defaultProps = {
  containerClassName: "",
};
